import { Link } from "react-router-dom";
import { cleanUp } from "../helpers/logout";

export default function LogoutPage() {
  cleanUp()

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">
        <h1 className="text-2xl font-bold mb-6 text-center">Бувайте,<br/>Ви вийшли з системи</h1>
        <Link
          to={"/login"}
          className="flex flex-col text-center p-6 mt-6 w-full bg-indigo-500 hover:bg-indigo-600 text-white font-semibold py-2 rounded-xl transition"
        >
          Увийти
        </Link>
      </div>
    </div>
  );
}
